import { Box } from "@chakra-ui/react";
import { ReactComponent as IconCopy } from "assets/icons/copy.svg";
import { NgFlagRounded } from "assets/icons/ng-flag-rounded";
import copy from "copy-to-clipboard";
import { IndividualContentItem } from "features/individual-compliance/selected-individual/IndividualContentItem";
import { FIRST_INDEX } from "features/individuals/individuals/individuals-list-table/const";
import { individualTypeCss } from "features/individuals/individuals/styles";
import { getKycLevel } from "utils/compliance";
import { THREE } from "utils/constants";
import {
  formatDateToDDMMMYYYY,
  formatDateToDDMMYYTTSS,
} from "utils/formatters";

import { customSuccessToast } from "ui/custom-toast";

import { IndividualTypeColorMap } from "../consts";
import { IIndividualContentItem, IndividualDetailsProps } from "./types";

export const IndividualUserDetails = (props: IndividualDetailsProps) => {
  const { isContentWrapperBelow600, isContentWrapperBelow745, individual } =
    props;

  const {
    accountName,
    accountNumber,
    phoneNumber,
    accountTier,
    email,
    id,
    bvnValidated,
    isFinalResult,
    kycAddressVerificationFile,
    createdAt,
    updatedAt,
    lastLogin,
  } = individual || {};

  const { color, bg } = accountTier
    ? // eslint-disable-next-line no-unsafe-optional-chaining
      IndividualTypeColorMap?.[accountTier]
    : IndividualTypeColorMap[FIRST_INDEX];

  const copyText = (text: string) => {
    if (text === "" || text === "N/A") return;
    copy(text);
    customSuccessToast({ message: `Copied: ${text}` });
  };

  const userDetails: IIndividualContentItem[] = [
    {
      title: "Account Name",
      content: accountName || "N/A",
    },
    {
      title: "Email Address",
      content: (
        <Box className="flex items-center lowercase">
          {email?.toLowerCase() || "N/A"}
        </Box>
      ),
    },
    {
      title: "Account Number",
      content: (
        <Box className="flex items-center">
          <p>{accountNumber || "N/A"}</p>
          {accountNumber && (
            <IconCopy
              onClick={() => copyText(accountNumber)}
              className="ml-1 cursor-pointer"
            />
          )}
        </Box>
      ),
    },
    {
      title: "User ID",
      content: (
        <Box className="flex items-center">
          <p>{id || "N/A"}</p>
          {id && (
            <IconCopy
              onClick={() => copyText(id)}
              className="ml-1 cursor-pointer"
            />
          )}
        </Box>
      ),
    },
    {
      title: "Phone Number",
      content: (
        <Box className="flex items-center">
          {phoneNumber ? (
            <>
              <NgFlagRounded className="mr-1" />
              <p>{phoneNumber}</p>
            </>
          ) : (
            "N/A"
          )}
        </Box>
      ),
    },
    {
      title: "Current Tier",
      content: (
        <Box
          className={`${accountTier !== THREE ? "w-[46px]" : "w-[48px]"}`}
          css={{ ...individualTypeCss, backgroundColor: bg, color }}
        >
          <p className="whitespace-nowrap">
            {accountTier ? `Tier ${accountTier}` : "Tier 0"}
          </p>
        </Box>
      ),
    },
    {
      title: "KYC Level",
      content: getKycLevel(
        bvnValidated!,
        isFinalResult!,
        kycAddressVerificationFile!
      ),
    },
    {
      title: "Date Joined",
      content: createdAt ? formatDateToDDMMMYYYY(createdAt) : "N/A",
      // content: "30th Mar, 2024",
    },
    {
      title: "Date Updated",
      content: updatedAt ? formatDateToDDMMMYYYY(updatedAt) : "N/A",
    },
    {
      title: "Last Login",
      content: lastLogin ? formatDateToDDMMYYTTSS(lastLogin!) : "N/A",
      // content: "15th Aug 2024 at 13:00 pm",
    },
  ];

  return (
    <Box className="flex flex-col gap-6">
      <Box>
        <Box
          css={{
            display: "flex",
            flexWrap: "wrap",
            columnGap: "32px",
            rowGap: "16px",
          }}
        >
          {userDetails.map((verificatioResult, index) => (
            <IndividualContentItem
              key={index}
              title={verificatioResult.title}
              content={verificatioResult.content}
              isContentWrapperBelow745={isContentWrapperBelow745}
              isContentWrapperBelow600={isContentWrapperBelow600}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
